
import { createServerService } from '@/lib/http/server'

const fetchServerData = async (apiName, params) => {
    // console.log("🚀 ~ fetchServerData ~ apiName:", apiName)
    // console.log("🚀 ~ fetchServerData ~ params:", params)
    try {
        const service = createServerService()
        const data = await service.get(apiName, params)
        return { data, error: null }
    } catch (error) {
        return { data: null, error: { ...error, apiName } }
    }
}

const isNull = (str) => {
    if (str === null || str === undefined || str.length === 0) {
        return true;
    }
    return false;
};

const throttle = (func, wait) => {
    let lastTime = 0;
    return function (...args) {
        const now = Date.now();
        if (now - lastTime >= wait) {
            func.apply(this, args);
            lastTime = now;
        }
    };
}

// 安全处理手机号脱敏的函数
const maskMobile = (mobile) => {
    if (!mobile || typeof mobile !== 'string') return '';

    // 清理手机号中的非数字字符
    const cleanMobile = mobile.replace(/\D/g, '');

    // 检查是否为有效的11位手机号
    if (cleanMobile.length === 11) {
        return `${cleanMobile.substring(0, 3)}****${cleanMobile.substring(7)}`;
    }

    // 处理非标准手机号：尝试保留后4位
    if (cleanMobile.length > 4) {
        const visibleDigits = 4;
        const start = cleanMobile.length - visibleDigits;
        return `****${cleanMobile.substring(start)}`;
    }

    // 过短的号码直接返回
    return cleanMobile;
};

const maskEmail = (email) => {
    if (!email || typeof email !== 'string') return '';
    const [localPart, domainPart] = email.split('@');
    if (!domainPart) return email; // 如果没有域名部分，直接返回原始邮箱
    const maskedLocalPart = localPart.length > 2 ? `${localPart[0]}**${localPart.slice(-1)}` : localPart;
    return `${maskedLocalPart}@${domainPart}`;
};


// 定义加密密钥
let secretKey = 'daydayup';

/**
 * 加密给定的数据。
 * @param {string} data 要加密的字符串。
 * @param {string} key 用于加密的密钥字符串。
 * @returns {string} 加密后的数据，以Base64编码形式返回。
 */
const encryptData = (data, key = secretKey) => {
    let result = '';
    // 遍历输入数据的每个字符，使用密钥字符进行异或操作，并将结果添加到最终结果字符串中
    for (let i = 0; i < data.length; i++) {
        result += String.fromCharCode(data.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    }
    // 对最终结果进行Base64编码，确保字符集兼容性并返回
    return encodeURIComponent(btoa(result));
}

/**
 * 解密数据
 * @param {string} data - 经过Base64编码且使用指定密钥加密的字符串
 * @param {string} key - 用于解密的密钥字符串
 * @returns {string} - 解密后的字符串
 */
const decryptData = (data, key = secretKey) => {
    // 使用Base64解码传入的数据
    data = atob(decodeURIComponent(data));
    let result = '';
    // 遍历解码后的字符串的每个字符，使用密钥进行异或解密
    for (let i = 0; i < data.length; i++) {
        result += String.fromCharCode(data.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    }
    return result;
}

const isCompleteImageUrl = (url) => {
    // 1. 基础URL验证
    if (!url || typeof url !== 'string') return false;

    // 2. 协议检查（必须包含HTTP/HTTPS）
    if (!/^https?:\/\//i.test(url)) return false;

    // 3. 常见图片扩展名检查
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
    const extensionPattern = new RegExp(`(${imageExtensions.join('|')})(\\?.*)?$`, 'i');

    return extensionPattern.test(url);
}

const getCookie = (name) => {
    const arrcookie = document.cookie.split('; ');
    const objCookie = {};
    arrcookie.forEach((cookie) => {
        const [name, val] = cookie.split('=');
        if (val && val !== '(null)') {
            objCookie[name] = decodeURIComponent(val);
        }
    });
    return objCookie[name] || '';
};

export {
    fetchServerData,
    isNull,
    throttle,
    maskMobile,
    maskEmail,
    encryptData,
    decryptData,
    getCookie,
    isCompleteImageUrl
}